const ANALYTICS_COOKIE_RE = /^_ga($|_)/;
const ANALYTICS_COOKIE_NAMES = new Set(["_ga", "_gid", "_gat"]);
const MARKETING_COOKIE_NAMES = new Set([
  "_fbp",
  "_fbc",
  "_ttp",
  "_tt_enable_cookie",
  "ttcsid",
  "li_sugr",
  "lidc",
  "bcookie",
  "bscookie",
  "li_gc",
  "AnalyticsSyncHistory",
  "UserMatchHistory",
  "lms_ads",
  "lms_analytics",
]);

const isAnalyticsCookie = (name) =>
  ANALYTICS_COOKIE_NAMES.has(name) || ANALYTICS_COOKIE_RE.test(name) || name.startsWith("_gat_");

const isMarketingCookie = (name) =>
  MARKETING_COOKIE_NAMES.has(name) || name.startsWith("_ttp") || name.startsWith("ttcsid");

const expireCookie = (name, extra = "") => {
  document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax${extra}`;
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax${extra}`;
};

const cookieExpireDomains = () => {
  const domains = new Set([
    ".gopaperless.quantera.vn",
    "gopaperless.quantera.vn",
    ".quantera.vn",
    "quantera.vn",
    ".facebook.com",
    ".linkedin.com",
    ".tiktok.com",
  ]);

  if (typeof window !== "undefined" && window.location?.hostname) {
    const host = window.location.hostname;
    if (host) {
      domains.add(host);
      domains.add(`.${host}`);
      const parts = host.split(".").filter(Boolean);
      if (parts.length >= 2) {
        const root = parts.slice(-2).join(".");
        domains.add(root);
        domains.add(`.${root}`);
      }
    }
  }

  return Array.from(domains);
};

const expireMatchingCookies = (predicate) => {
  if (typeof document === "undefined") return;

  const names = document.cookie
    .split("; ")
    .filter(Boolean)
    .map((row) => row.split("=")[0]);

  names.forEach((name) => {
    if (!predicate(name)) return;
    expireCookie(name);
    cookieExpireDomains().forEach((domain) => {
      expireCookie(name, `; domain=${domain}`);
    });
  });
};

export const clearAnalyticsCookies = () => expireMatchingCookies(isAnalyticsCookie);

export const clearMarketingCookies = () => expireMatchingCookies(isMarketingCookie);

export const COOKIE_SWEEP_INTERVAL_MS = 400;
export const COOKIE_SWEEP_DURATION_MS = 8000;

const sweepTimers = {};

export const stopCookieSweep = (name) => {
  if (typeof window === "undefined") return;
  if (sweepTimers[name]) {
    clearInterval(sweepTimers[name]);
    sweepTimers[name] = null;
  }
};

export const startCookieSweep = (name, clearFn) => {
  if (typeof window === "undefined") return;
  stopCookieSweep(name);
  clearFn();
  const maxTicks = Math.ceil(COOKIE_SWEEP_DURATION_MS / COOKIE_SWEEP_INTERVAL_MS);
  let ticks = 0;
  sweepTimers[name] = setInterval(() => {
    clearFn();
    ticks += 1;
    if (ticks >= maxTicks) {
      stopCookieSweep(name);
    }
  }, COOKIE_SWEEP_INTERVAL_MS);
};
